import React, { Component } from 'react'
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import logologin from '../../Comman/images/logo-new.png'
import { withRouter } from 'react-router-dom';

import { Redirect } from 'react-router-dom'
import loader from '../../Comman/images/loader.gif'

class HeartRunnerLoginComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      redirect: false,
      adminRadio: false,
      heartRunnerRadio:true,
      userRadio: false,
      redirectAdmin: false,
      redirectUser: false,
      redirectPassword: false,

    };
    
  }

  
  renderRedirectForgotPassword = () => {
    if (this.state.redirectPassword) {
      return <Redirect to='/forgotpassword' />
    }
  }
  

  setRedirectSignUp = () => {
    this.props.history.push('/registration')
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  Login = event => {
    event.preventDefault();
    if (this.validateForm()) {
      this.props.heartRunnerLogin(this.state.username, this.state.password);
    }
    else {
      let fields = {};
      fields["username"] = "";
      fields["password"] = "";
      this.setState({ fields: fields });
      //document.getElementById("errorMsg").innerText = "Please Enter Username & Password";
      alert("Please Enter Username & Password !")
    }
    
  }

  validateForm() {
    if (this.state.username.length > 0 && this.state.password.length > 0)
      return true;
    else
      return false;
  }
   resetPassword=(e)=>{
      this.setState({redirectPassword:true})
  }


  render() {
    console.log(this.props)
    return (
    <div className="loginbg">
     <div className="login-main ">
          <div className="login-logo">
            <img src={logologin} />
          </div>
          
          {this.props.loginDet.loginStatus !== 200 ?
                        <span className="lbl_danger"> {this.props.loginDet.message !== '' ? this.props.loginDet.message : ""}</span>
                        : <span className="lbl_success"> {this.props.loginDet.messageLabel !== '' ? this.props.loginDet.messageLabel : ""}</span>
                    }
          <form onSubmit={this.Login} >
          <div className="login-fm">
            <FormGroup controlId="username">
             
              <FormControl
                className="login-main-form-control"
                autoFocus
                type="text"
                value={this.state.username}
                onChange={this.handleChange}
                placeholder="Enter username"
              />
            </FormGroup>
            </div>
            <div className="login-fm">
            <FormGroup controlId="password">
             
              <FormControl
                className="login-main-form-control"
                value={this.state.password}
                onChange={this.handleChange}
                type="password"
                placeholder="Enter password"
              />
            </FormGroup>
            </div>
            <div className="login-button">
              <Button type="login"> LOGIN  {
                this.props.loginDet.isLoading?  
                <i className="fa fa-spinner fa-spin pl-md-2" ></i>
                :'' 
                }
                </Button> 
              
              {this.renderRedirectForgotPassword()}
              <p>
              <a href="#"><span className="yellow"><button className="signUp" onClick={this.resetPassword}>FORGOT YOUR PASSWORD? </button></span></a>
              <a href="#"><span className="yellow"><button className="signUp" onClick={this.setRedirectSignUp}>SIGN UP</button></span></a>
              </p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(HeartRunnerLoginComponent)
